const state = new WeakMap();

// class name constants
const BOUNDS_CLASS = "bounds";
const BOUNDS_TOP_CLASS = "top";
const BOUND_RIGHT_CLASS = "right";
const BOUNDS_BOTTOM_CLASS = "bottom";
const BOUNDS_LEFT_CLASS = "left";

const handleScroll = (el) => {
	const elState = state.get(el);
	const elBounds = el.getBoundingClientRect();
	const vWidth = window.innerWidth;
	const vHeight = window.innerHeight;

	if (elState.active) {
		// top bounds
		if (elBounds.top - elState.offsets.top <= 0) {
			el.classList.add(BOUNDS_TOP_CLASS);
		} else {
			el.classList.remove(BOUNDS_TOP_CLASS);
		}

		// right bounds
		if (elBounds.right + elState.offsets.right >= vWidth) {
			el.classList.add(BOUND_RIGHT_CLASS);
		} else {
			el.classList.remove(BOUND_RIGHT_CLASS);
		}

		// bottom bounds
		if (elBounds.bottom + elState.offsets.bottom >= vHeight) {
			el.classList.add(BOUNDS_BOTTOM_CLASS);
		} else {
			el.classList.remove(BOUNDS_BOTTOM_CLASS);
		}

		// left bounds
		if (elBounds.left - elState.offsets.left <= 0) {
			el.classList.add(BOUNDS_LEFT_CLASS);
		} else {
			el.classList.remove(BOUNDS_LEFT_CLASS);
		}
	} else {
		el.classList.remove(BOUNDS_TOP_CLASS);
		el.classList.remove(BOUND_RIGHT_CLASS);
		el.classList.remove(BOUNDS_BOTTOM_CLASS);
		el.classList.remove(BOUNDS_LEFT_CLASS);
	}
};

export default {
	inserted(el, binding) {
		let active;
		let offsets = {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};

		if (binding.value !== false) {
			offsets = {
				...offsets,
				...binding.value
			};

			active = true;
		} else {
			active = false;
		}

		el.classList.add(BOUNDS_CLASS);

		const onScroll = () => {
			handleScroll(el, active, offsets);
		};

		// listen to scroll events
		window.addEventListener("scroll", onScroll);

		// add listener to weak map for later clean-up
		state.set(el, {
			onScroll,
			offsets,
			active
		});
	},

	update(el, binding) {
		const elState = state.get(el);

		let active;
		let offsets = {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};

		if (binding.value !== false) {
			offsets = {
				...binding.value
			};

			active = true;
		} else {
			active = false;
		}

		state.set(el, {
			...elState,
			offsets,
			active
		});
	},

	unbind(el) {
		const elState = state.get(el);

		window.removeEventListener("scroll", elState.onScroll);

		state.delete(el);
	}
};
